import { FMSServiceReturnData, UnitInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class LegacyServerAPI {
  static async processScheduledMessage(body: { data: any }, params?: any): Promise<FMSServiceReturnData<UnitInterface[]>> {
    return APIService.LegacyServer.post(`/processor/process-scheduled-message`, body, params);
  }
  static async doesParseUserExist(email: string, password: string): Promise<{ userExists: boolean; user: any; permissions: any }> {
    return APIService.LegacyServer.post<{ userExists: boolean; user: any; permissions: any }>(`/../user/does-parse-user-exist`, { email, password });
  }
}
